export const environment = {
  production: false,
  envName: 'test',

  googleMapsKey: 'AIzaSyA26-WDibGT-E7cY5EPqmyQ6-HAMb3-ENQ',

  // domainBaseUrl: "https://kisnastoresv2.sdaemon.com/",
  // apiBaseUrl: "https://localhost:57526/api/",
  // apiurl: "https://localhost:57526/",
  // fileUrl: "https://localhost:57526",


  domainBaseUrl: "https://kisnastoresv2.sdaemon.com/",
  apiBaseUrl: "https://kisnastoresv2api.sdaemon.com/api/",
  apiurl: "https://kisnastoresv2api.sdaemon.com/",
  fileUrl: "https://kisnastoresv2api.sdaemon.com",
  kmrApiBaseUrl: "",

  // domainBaseUrl: "https://kisnastorev2.kisna.com/",
  // apiBaseUrl: "https://kisnastoresv2api.kisna.com/api/",
  // apiurl: "https://kisnastoresv2api.kisna.com/",
  // fileUrl: "https://kisnastoresv2api.kisna.com",
  // kmrApiBaseUrl: "",
};

// npm run build:test